<!--
  メダル取得履歴の表示
-->
<template>
  <v-main class="pa-0">
    <div class="pa-4 d-flex">
      <p class="mb-0 pagetitle">メダルの獲得履歴</p>
      <v-spacer></v-spacer>
      <v-icon v-if="device==='pc'" x-large @click="$emit('closeProfile')">mdi-close</v-icon>
    </div>
    <v-card v-if="displayque.length == 0">
      <v-card-text>このユーザーにはメダルの獲得履歴がありません。</v-card-text>
    </v-card>
    <v-list id="medalloglog" v-else class="overflow-x-hidden overflow-y-auto" style="height:75vh;">
      <v-list-item v-for="medallog in displayque" :key="medallog.id">
        <v-card class="mx-auto" width="300px" min-height="50">
          <v-container>
            <v-row>
              <v-col cols="2" class="d-flex pr-0">
                <v-img class="my-auto" src="../../../assets/svg/5039.svg" width="40px"></v-img>
              </v-col>
              <v-col cols="10">
                <p class="mb-0 cloud--text">
                  {{ medallog.jdate.getFullYear() }}年
                  {{ medallog.jdate.getMonth() + 1 }}月
                  {{ medallog.jdate.getDate() }}日
                  {{ medallog.jdate.getHours().toString().padStart(2, "0") }}：{{ medallog.jdate.getMinutes().toString().padStart(2, "0")}}                  
                </p>
                <div>
                  <div class="float" v-if="medallog.logclass == 'ideapost'">
                    {{$t('アイデア')}}投稿数
                  </div>
                  <div class="float" v-else-if="medallog.logclass == 'proposals'">
                    案投稿数
                  </div>
                  <div class="float" v-else-if="medallog.logclass == 'comments'">
                    コメント投稿数
                  </div>
                  <div
                    class="float"
                    v-else-if="medallog.logclass == 'amendments'"
                  >
                    修正提案投稿数
                  </div>
                  <div class="float" v-else-if="medallog.logclass == 'like'">
                    いいね数
                  </div>
                  <div class="float" v-else>{{ medallog.logclass }}</div>

                  <div class="float" v-if="medallog.medals == 1">1</div>
                  <div class="float" v-else-if="medallog.medals == 2">10</div>
                  <div class="float" v-else-if="medallog.medals == 3">100</div>
                  <div>
                    件達成により、メダルを
                    {{ medallog.medals }}
                    枚獲得しました
                  </div>                  
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-list-item>
    </v-list>
    <v-card height="100" elevation="0">
    </v-card>
  </v-main>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default {
  data() {
    return {
      db: firebase.firestore(),
      displayque: [],
    };
  },
  components: {},
  props: ["profuid", "device"],

  watch: {
    profuid: function (profuid) {
      this.getlog();
    },
  },
  mounted() {
    this.getlog();
  },
  methods: {
    getlog(logclass = null) {
      let myque = [];
      if (logclass == null) {
        let usedday = [];
        let collection = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.profuid)
          .collection("medal")
          .orderBy("date", "desc");
        collection
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let logdata = doc.data();
              logdata.jdate = logdata.date.toDate();
              logdata.ymd =
                logdata.jdate.getFullYear() * 10000 +
                (logdata.jdate.getMonth() + 1) * 100 +
                logdata.jdate.getDate();
              myque.push(logdata);
            });
          })
          .catch((error) => {
            //console.log("メダルログの取得でエラーが発生しました", error);
          });
      }
      this.displayque = myque;
    },
  },
};
</script>
<style scoped>
.pagetitle {
  font-size: 25px;
  color: #707070;
}
.float {
  float: left;
}
* {
  font-family: mplus-2c-medium;
}
</style>